import { render } from "./regarding.vue?vue&type=template&id=27db2c56&scoped=true"
import script from "./regarding.vue?vue&type=script&lang=js"
export * from "./regarding.vue?vue&type=script&lang=js"

import "./regarding.vue?vue&type=style&index=0&id=27db2c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db2c56"]])

export default __exports__